<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="!allInformationLoaded" />
    </transition>
    <div class="blackscreen" v-if="isFullscreen"></div>
    <div class="single-game-wrapper">
      <div class="container min-w-60">
        <div
          v-if="!currentGameDescription.coming_soon"
          ref="gameIframe"
          :class="
            isFullscreen
              ? 'game-fullscreen fullscreen col-lg-12 col-md-12 col-sm-12 col-xs-12'
              : 'game-fullscreen col-lg-12 col-md-12 col-sm-12 col-xs-12'
          "
        >
          <div
            class="game-details_iframe-container"
            :class="[
              isFullscreen ? 'pb-0' : '',
              shouldApplyCrashClass ? 'min-h-crash' : '',
              !isFullscreen && game_type === 'crash-game'
                ? `zoom-crash ${this.$route.params.id}`
                : '',
            ]"
          >
            <div class="loader-wait-game" v-show="!isGameFrameReady">
              <div class="loader-spin"></div>
            </div>
            <iframe
              :src="customPath"
              frameborder="0"
              :scrolling="game_type === 'crash-game' ? 'yes' : 'no'"
              allowfullscreen="true"
              @load="onIframeLoad"
            ></iframe>
          </div>
          <div class="game-details__iframe-nav">
            <a
              @click="returnToGamePage"
              class="game-details__iframe-btn back-to-games_Page-btn"
            >
              <span>{{
                translations?.slot_page?.back_to_games ?? "Back to Games"
              }}</span>
            </a>
            <a
              class="game-details__iframe-btn exit-fullscreen-btn"
              @click="toggleFullscreen"
            >
              <span class="fullscreen-cta-btn">{{
                !isFullscreen
                  ? translations?.slot_page?.fullscreen ?? "Fullscreen"
                  : translations?.slot_page?.exit_fullscreen ??
                    "Exit Fullscreen"
              }}</span>
            </a>
          </div>
        </div>
        <div class="game-information-container">
          <h1 class="game-name">{{ game_name }}</h1>
          <div v-html="description ?? 'No Description available'"></div>
        </div>
        <div class="language-currency-wrapper" v-if="0">
          <v-menu transition="slide-y-transition" class="language-changer-btn">
            <template v-slot:activator="{ props }">
              <v-btn color="white" v-bind="props" class="language-filter-text">
                Language
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                class="language-item-dropdown"
                v-for="(language, i) in languages"
                :key="i"
              >
                <v-list-item-title @click="changeLanguage(language.code)">{{
                  language.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu transition="slide-y-transition" class="currency-changer-btn">
            <template v-slot:activator="{ props }">
              <v-btn color="white" v-bind="props" class="currency-filter-text">
                Currency
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                class="currency-item-dropdown"
                v-for="(currency, i) in currencies"
                :key="i"
              >
                <v-list-item-title @click="changeCurrency(currency.code)">{{
                  currency.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <button class="btn reload-page-btn">Reload Page</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/Global/PreLoader.vue";
// import { replace } from "core-js/fn/symbol";
import { mapGetters } from "vuex";

export default {
  name: "SlotPage-Detail",
  components: {
    PreLoader,
  },
  data() {
    return {
      lang: "en",
      allInformationLoaded: false,
      isFullscreen: false,
      fullscreenWork: false,
      isGameFrameReady: false,
      customPath: "",
      game_type: "",
      game_name: "",
      selectedCurrency: sessionStorage.getItem("currency") ?? "EUR",
      selectedLanguage: "en",
      provider_slug: "theearcasino",
      description: "",
      provider_id: 207,
      languages: [
        { code: "en", title: "English" },
        { code: "it", title: "Italian" },
        { code: "de", title: "German" },
      ],
      currencies: [
        { code: "EUR", title: "EUR" },
        { code: "USD", title: "USD" },
        { code: "GBP", title: "GBP" },
      ],
    };
  },
  computed: {
    ...mapGetters("Translations", ["isTranslationLoading", "translations"]),
    ...mapGetters("casinoGames", [
      "currentGamePath",
      "isAllSkinGamesLoading",
      "games",
      "currentGameDescription",
    ]),
    shouldApplyCrashClass() {
      const isMobile = window.innerWidth <= 600;
      return this.game_type === "crash-game" && isMobile;
    },
  },
  methods: {
    // Navigation
    returnToGamePage() {
      window.location.href = "/games";
    },

    restoreOverflow() {
      document.body.style.overflow = "";
      document.body.style.scrollbarWidth = "thin";
      document.documentElement.style.scrollbarWidth = "thin";
    },

    // Language and Currency Management
    changeCurrency(newCurrency) {
      sessionStorage.setItem("currency", newCurrency);
      this.selectedCurrency = newCurrency;
      this.selectedLanguage = sessionStorage.getItem("language");
      window.location.reload();
    },
    changeLanguage(newLanguage) {
      sessionStorage.setItem("language", newLanguage);
      this.selectedCurrency = sessionStorage.getItem("currency");
      this.selectedLanguage = newLanguage;
      window.location.reload();
    },

    // Game Path Initialization
    async componePath() {
      let id = this.$route.params.id;
      if (id == "flywithaugustus") {
        let path = this.currentGamePath;
        this.customPath = path.replace(/-stage|stage-/g, "");
      } else {
        this.customPath = this.currentGamePath;
      }
    },

    // Fullscreen Management
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      this.removeOverflow();
    },
    handleEscapeKey(event) {
      if (event.key === "Escape" && this.isFullscreen) {
        this.isFullscreen = false;
        this.removeOverflow();
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
      this.removeOverflow();
    },

    removeOverflow() {
      document.body.style.overflow = this.isFullscreen ? "hidden" : "";
      document.body.style.scrollbarWidth = this.isFullscreen ? "none" : "thin";
      document.documentElement.style.scrollbarWidth = this.isFullscreen
        ? "none"
        : "thin";
    },

    // Iframe Loading
    onIframeLoad() {
      setTimeout(() => {
        this.isGameFrameReady = true;
      }, 2500);
    },

    // Metadata Management
    setMetaTags() {
      const title = `The Ear | ${this.game_name}`;
      const metaDescription = `Discover our exciting ${this.game_name}!`;

      document.title = title;

      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", metaDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.name = "description";
        newMetaTag.content = metaDescription;
        document.head.appendChild(newMetaTag);
      }
    },
    activeListener() {
      // Event listeners
      document.addEventListener("keydown", this.handleEscapeKey);
      document.addEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "mozfullscreenchange",
        this.handleFullscreenChange
      );
    },
    async killListener() {
      // Clean up event listeners
      document.removeEventListener("keydown", this.handleEscapeKey);
      document.removeEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        this.handleFullscreenChange
      );
    },
  },
  async created() {
    // Set initial game path and toggle fullscreen for mobile
    // await this.componePath();
    if (window.innerWidth <= 600) {
      this.toggleFullscreen();
    }

    // Set initial currency and language
    this.selectedCurrency = sessionStorage.getItem("currency") ?? "all";
    this.selectedLanguage = sessionStorage.getItem("language") ?? "en";

    // Fetch game details
    const { id, token } = this.$route.params;
    await this.$store
      .dispatch("casinoGames/callGamesDetail", { id, lang: this.lang })
      .then(() => {
        const { description, name, type } = this.currentGameDescription ?? {};
        this.description = description;
        this.game_name = name;
        this.game_type = type;
        this.setMetaTags();
      });

    // Initialize demo mode and load all information
    this.$router.push(`/gameDetail/${id}/${token}`);
    await this.$store
      .dispatch("casinoGames/play_demo", {
        game_id: id,
        provider_slug: this.provider_slug,
        currency: this.selectedCurrency,
        language: this.selectedLanguage,
      })
      .then(() => {
        setTimeout(() => {
          this.allInformationLoaded = true;
        }, 1000);
      });

    this.activeListener();
    await this.componePath();
  },
  async beforeUnmount() {
    if (this.isFullscreen) {
      this.restoreOverflow();
    }
    await this.killListener();
  },
};
</script>

<style lang="scss" scoped>
.single-game-wrapper {
  padding-top: 140px;
  background-color: #09041f;
  color: #fff;
  overflow: unset;
}

.fullscreen {
  display: block;
  border: none;
  max-height: 100vh;
  width: 100vw;
  padding-top: 0px;
  position: fixed;
  z-index: 1200;
  left: 0px;
  right: 0px;
  top: 0;
  bottom: 0px;
  overflow: hidden !important;
  transition: 0.3s all;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: column;
}

.game-fullscreen {
  overflow: hidden;
  padding-bottom: 25px;
  transition: 0.3s all;
}

.game-details_iframe-container {
  position: relative;
  overflow: hidden;
  height: 100%;
  max-width: 100%;
  /* padding-bottom: 56.25%; */
  padding-bottom: 46.25%;
  transition: 0.3s all;
  // border-radius: 8px 8px 0px 0px;
  background-color: black;
}

.game-details_iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s all;
  background: black;
}

.game-details__iframe-nav {
  background: black;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  z-index: 20;
  position: relative;
  width: 100%;
  min-height: 25px;
  top: -1px;
  // border-radius: 0px 0px 8px 8px;
}

.game-details__iframe-nav a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
}

.exit-fullscreen-btn,
.back-to-games_Page-btn {
  cursor: pointer;
  transition: 0.3s all;
}

.exit-fullscreen-btn:hover,
.back-to-games_Page-btn:hover {
  color: lightgray;
  text-decoration: underline;
  transform: scale(1.02);
  transition: 0.3s all;
}

.close-fullscreem-btn:hover {
  color: grey;
}

.game-details__iframe-closeFrame {
  z-index: 100;
  color: black;
  position: fixed;
  top: 3%;
  right: 2%;
  background: white;
  padding: 5px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}

.game-information-container {
  padding: 30px 0px 30px;
}

.game-name {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 10px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: center;
  color: #fff;
}

.game-description {
  font-size: 16px;
  line-height: 1.8rem;
}

.key-features {
  font-size: 16px;
  line-height: 1.8rem;
  font-weight: 600;
}

li {
  padding-left: 0px;
}

ul {
  padding-left: 1rem;
}

.language-currency-wrapper {
  display: inline-block;
  width: 100%;
  margin: 0 0 20px;
}

.language-changer-btn {
  margin: 0px 10px;
}

.currency-changer-btn {
  margin: 0px 10px;
}

.language-filter-text {
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 1rem;
  margin: 0px 10px 0px 0px;
}

.currency-filter-text {
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 1rem;
  margin: 0px 10px 0px 0px;
}

.language-item-dropdown {
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 1rem;
  cursor: pointer;
}

.currency-item-dropdown {
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 1rem;
  cursor: pointer;
}

.language-item-dropdown:hover {
  background: yellow;
  color: black;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
}

.currency-item-dropdown:hover {
  background: yellow;
  color: black;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
}

.reload-page-btn {
  background: cornflowerblue;
  color: white;
  font-weight: 700;
  border-radius: 999px;
}

.reload-page-btn:hover {
  background: rgb(83, 134, 230);
}

.game-base_information {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: baseline;
  font-size: 1rem;
  margin: 0 0 25px;
}

@media screen and (min-width: 1170px) {
  .single-game-wrapper .container {
    width: 970px;
  }
}
.single-game-wrapper .container {
  position: relative;
}
.section--all-games .container {
  max-width: 1020px;
  width: 100%;
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (max-width: 767px) and (min-width: 576px) {
  .container {
    width: 95%;
  }
}

@media (max-width: 575px) {
  .container {
    width: 95%;
  }
  .game-fullscreen {
    overflow: hidden;
    width: 100%;
    padding-bottom: 25px;
  }

  .game-details_iframe-container {
    position: relative;
    overflow: hidden;
    height: 100%;
    max-width: 100%;
    // padding-bottom: 0% !important;
    background-color: black;
  }

  .game-details_iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 421px) {
  .reload-page-btn {
    background: cornflowerblue;
    color: white;
    font-weight: 700;
    border-radius: 999px;
    margin: 10px 0 0;
  }
}
@media (max-width: 767px) {
  // .fullscreen-cta-btn {
  //   display: none;
  // }
}

.min-w-60 {
  // min-width: 70% !important;
}

.blackscreen {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1199;
  background-color: black;
  overflow: hidden;
  scrollbar-width: none !important;
}

.loader-wait-game {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  z-index: 12;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
}

.loader-spin {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}

@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

@media (max-width: 650px) and (max-height: 1000px) {
  .min-h-crash {
    min-height: 30vh !important;
  }
}

.flywithaugustus {
  zoom: 70% !important;
}

.earplane {
  zoom: 85% !important;
}

@media screen and (max-width: 1199px) and (min-width: 768px) {
  .flywithaugustus {
    zoom: 60% !important;
  }
}

@media screen and (max-width: 767px) {
  .flywithaugustus {
    zoom: 100% !important;
  }

  .earplane {
    zoom: 100% !important;
  }
}
</style>
